(() => {
  const handle = "seibertron-t-t-f-i-g-2-0-tactical-fingerless-gloves";
  const assetName = "ttfig-2-0-fingerless-size-chart-vertical-20260714.jpg";
  const oldAssetName = "ttfig-2-0-adult-size-chart-original.jpg";
  const alt = "Seibertron T.T.F.I.G 2.0 tactical fingerless gloves vertical size chart";
  const width = 1000;
  const height = 1000;

  function isTargetPage() {
    return location.pathname.indexOf('/products/' + handle) !== -1;
  }

  function chartUrl() {
    const script = document.currentScript || Array.prototype.slice.call(document.scripts).find((node) => {
      return String(node.src || '').indexOf("ttfig-fingerless-sizechart-restore-20260714") !== -1;
    });
    if (script && script.src) {
      try {
        return new URL(assetName + '?v=202607141830', script.src).href;
      } catch (error) {}
    }
    return '/cdn/shop/files/' + assetName + '?v=202607141830';
  }

  function apply() {
    if (!isTargetPage()) return;
    document.querySelectorAll('img').forEach((img) => {
      const src = String(img.getAttribute('src') || '');
      const text = String(img.getAttribute('alt') || '');
      const isSizeChart =
        src.indexOf(oldAssetName) !== -1 ||
        src.indexOf(assetName) !== -1 ||
        /T\.T\.F\.I\.G.*size chart/i.test(text);
      if (!isSizeChart) return;
      img.src = chartUrl();
      img.srcset = '';
      img.alt = alt;
      img.width = width;
      img.height = height;
      img.loading = 'lazy';
      img.decoding = 'async';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  setTimeout(apply, 600);
  setTimeout(apply, 1800);
})();